import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PutCoveragesFailure, PutCoveragesRequest, PutCoveragesSuccess } from './actions';
import { PutCoveragesService } from './service';

@Injectable()
export class PutCoveragesEffects {
  private readonly actions$ = inject(Actions);
  private readonly putCoveragesService = inject(PutCoveragesService);

  putCoverages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PutCoveragesRequest),
      switchMap(({ body, parameters }) =>
        this.putCoveragesService.putCoverages(body, parameters).pipe(
          map(data => PutCoveragesSuccess({ data })),
          catchError(error => of(PutCoveragesFailure({ error })))
        )
      )
    )
  );

}
